module.exports = __webpack_public_path__ + "img/mpesa.9ca22b87.png";